// Application logger.
//
// `debug` and `info` are stripped at build time in production via Vite's
// dead-code elimination on the `import.meta.env.DEV` constant. `warn` and
// `error` always log — those represent real signal and will be picked up
// by Sentry once it's wired (M-C). Sentry's default behaviour captures
// `console.error` as an event and `console.warn` as a breadcrumb, so we
// don't need to manually report from this module.
//
// Use this in place of `console.*` for anything that's NOT a user-facing
// error. Per-render logs and "loaded X items" telemetry should be
// `logger.debug(...)` so they vanish from production builds.

// Static member access on purpose — an optional-chained read is dynamic to
// Vite and materializes the whole VITE_* env into the bundle (see
// test-no-client-secret check #4). `import.meta.env` always exists under Vite.
const isDev = import.meta.env.DEV ?? false;

export const logger = {
  debug: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};
